module.exports = __webpack_public_path__ + "static/media/massage-4.801757f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/slider/massage-4.jpg
// module id = 599
// module chunks = 6